<template>
  <div class="actityDetails">
    <div class="define-header" v-if="declarePostShow">
      <span class="title">申报输入项目</span>
    </div>
    <div class="actitiy-content">
      <div class="actityLeft">
        <div class="actityLeftHeader">
          <span style="margin-right:15px;color:#333;font-size:14px;">新增项目</span>
          <el-select
            popper-class="my-el-scroll"
            v-model="moblieListValue"
            placeholder="请选择"
            style="margin-right:10px;"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="addMobLieList">确定</el-button>
        </div>
        <div class="actityLeftContent">
          <div class="content-bar"></div>
          <div class="content-box">
            <div class="boxList">
              <vuedraggable @end="end">
                <div
                  v-for="(item,itemKey) in newMoblieList"
                  :class="item.active? 'box-item active': 'box-item'"
                  :key="item.label + itemKey"
                  style="position:relative;"
                  @click="changeMoblie(itemKey)"
                >
                  <i
                    v-show="item.required"
                    style="position:relative;color:#f00;top:-4px;left:-2px;"
                  >*</i>
                  <span>{{item.label}}</span>
                  <span class="slot" style="color:#D3D0D0FF;float:right;margin-right:14px;">
                    <i
                      v-if="item.interface === 'singlebox' || item.interface === 'checkbox' || item.interface === 'date' || item.interface === 'changeTeacher' || item.interface === 'changeStudent'"
                      class="el-icon-arrow-right"
                    ></i>
                    <i
                      v-if="item.interface === 'uploadImg' || item.label === '获奖照片'"
                      class="el-icon-camera"
                    ></i>
                    <i v-if="item.interface === 'annex'" class="el-icon-link"></i>
                    {{item.interface === 'multiLineInputbox' || item.interface === 'singleLineInputbox' || item.label === '获奖名称' || item.interface === 'descriptionText'? '请输入' : ''}}
                  </span>
                  <span></span>
                  <div
                    class="deleteItem"
                    style="position:absolute;top:0;right:0;width:12px;height:12px;"
                    @click.stop="deleteOption(itemKey)"
                    v-show="!item.forSubject"
                  >
                    <img
                      src="../../../../assets/image/classroom/epeople-teacher/delete.png"
                      style="width:100%;height:100%;position:relative;top:-10px;cursor:pointer;"
                      alt
                    />
                  </div>
                </div>
              </vuedraggable>
            </div>
          </div>
        </div>
      </div>
      <div class="actityRight">
        <div
          class="actity-content"
          v-for="(item,itemKey) in newMoblieList"
          :key="itemKey"
          v-show="item.active"
        >
          <div class="header" v-if="item.interface !== 'descriptionText'">
            <span class="title" >标题</span>
            <span class="message">(最多20字)</span>
          </div>
          <el-input :disabled="item.forSubject" placeholder="最多20个字" maxlength="20" v-model="item.label" v-if="item.interface !== 'descriptionText'"></el-input>
          <div class="content" v-if="item.interface !== 'descriptionText'">
            <span class="title">必填</span>
            <div :class="{'not-allowed': item.forSubject}" class="select-button" @click="selectIng(itemKey, item.forSubject)">
              <span :class="item.required? 'active': 'none'">是</span>
              <span :class="!item.required? 'active': 'none'">否</span>
            </div>
          </div>
          <div class="option" v-if="item.interface === 'checkbox'">
            <div class="header">
              <span class="title">选项</span>
              <span class="message">（每行一个选项，每行最多50字）</span>
              <div class="text">
                <el-input
                  type="textarea"
                  :disabled="beyonded"
                  style="width:330px;min-height:200px;"
                  placeholder="每行一个选项，每项最多20个字"
                  v-model="item.content"
                ></el-input>
              </div>
            </div>
            <span v-if="beyond" style="color:red;">选项超过50字</span>
          </div>
          <div class="option" v-if="item.interface === 'singlebox'">
            <div class="header">
              <span class="title">选项</span>
              <span class="message">（每行一个选项，每行最多20字）</span>
              <div class="text">
                <el-input
                  type="textarea"
                  :disabled="beyonded || item.forSubject"
                  style="width:330px;min-height:200px;"
                  placeholder="每行一个选项，每项最多20个字"
                  v-model="item.content"
                ></el-input>
              </div>
            </div>
            <span v-if="beyond" style="color:red;">选项超过20字</span>
          </div>
          <!-- 图片 -->
          <div class="option" v-if="item.interface === 'uploadImg'">
            <el-dialog title :visible.sync="item.dialogVisible" width="30%">
              <span>
                <el-upload
                  :action="item.url"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :http-request="fnUploadRequest"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <el-dialog :visible.sync="item.dialogVisible"> -->
                <img width="100%" :src="item.dialogImageUrl" alt />
                <!-- </el-dialog> -->
              </span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="item.dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="item.dialogVisible = false">确 定</el-button>
              </span>
            </el-dialog>
          </div>
          <!-- 单行输入框 -->
          <div class="option" v-if="item.interface === 'ownInput'">单行输入框</div>
          <!-- 多行输入框 -->
          <div class="option" v-if="item.interface === 'manyInput'">多行输入框</div>
          <!-- 日期 -->
          <div class="option" v-if="item.interface === 'date'">
            <span class="title">日期类型</span>
            <el-radio v-model="item.dateType" style="display:block;margin-top:5px;" label="1">年-月-日</el-radio>
            <el-radio v-model="item.dateType" style="display:block;margin-top:5px;" label="2">年-月-日 时:分</el-radio>
          </div>
          <!-- 附件 -->
          <div class="option" v-if="item.interface === 'annex'"></div>
          <!--选择老师  -->
          <div class="option" v-if="item.interface === 'changeTeacher'">
          </div>
          <!-- 说明文字 -->
          <div class="option" v-if="item.interface === 'descriptionText'">
            <div class="header">
              <span class="title">说明文字</span>
              <span class="message">（说明文字，最多2000字）</span>
              <div class="text">
                <el-input
                  type="textarea"
                  style="width:330px;min-height:200px;"
                  placeholder="说明文字，最多2000字"
                  v-model="item.content"
                ></el-input>
              </div>
            </div>
          </div>
          <!-- 选择学生 -->
          <div class="option" v-if="item.interface === 'changeStudent'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import axios from "axios";
export default {
  name: "publicDefine",
  props: {
    oldContent: {
      type: String,
      default: ""
    },
    subjectList: {
      type: String,
      default: ''
    }
  },
  computed: {
    declarePostShow() {
      return this.$store.state.declarePostMessage.active;
    }
  },
  watch: {
    declarePostShow: {
      handler(newVal) {},
      deep: true
    },
    newMoblieList: {
      handler(newVal) {
        if (newVal[this.key]) {
          try {
            let arr = newVal[this.key].content.split(/[(\r\n)\r\n]+/);
            arr.forEach(item => {
              if (item.length > 50) {
                this.beyond = true;
                this.beyonded = true;
                setTimeout(() => {
                  this.beyonded = false;
                }, 0.5);
              } else {
                this.beyond = false;
                this.beyonded = false;
              }
            });
          } catch (error) {}
        }
        if (this.$route.path === "/declareDefine") {
          // 申报定义content数据
          this.$emit("watchDeclareContentPostMessage", newVal);
        } else {
          // 活动定义数据
          this.$emit("watchActivityContentMessage", newVal);
        }
      },
      deep: true
    },
    oldContent: {
      handler(newVal) {
        if (newVal === "") {
          this.newMoblieList = [];
          this.hasImg = false;
          this.hasAnnex = false;
          return;
        }
        let oldContent = this.judge(newVal);
        if (oldContent.content) {
          this.newMoblieList = oldContent.content;
        } else {
          this.newMoblieList = [];
        }
      },
      deep: true
    }
  },
  components: {
    vuedraggable
  },
  data() {
    const moblieList = [
      {
        label: "说明文字",
        required: false,
        active: false,
        interface: "descriptionText",
        content: ""
      },
      {
        label: "单选框",
        required: false,
        active: false,
        interface: "singlebox",
        content: ""
      },
      {
        label: "多选框",
        required: false,
        active: false,
        interface: "checkbox",
        content: ""
      },
      {
        label: "上传图片",
        required: false,
        active: false,
        interface: "uploadImg",
        dialogImageUrl: "",
        dialogVisible: false,
        content: "",
        url: "",
        urlList: []
      },
      {
        label: "单行输入框",
        required: false,
        active: false,
        interface: "singleLineInputbox",
        content: ""
      },
      {
        label: "多行输入框",
        required: false,
        active: false,
        interface: "multiLineInputbox",
        content: ""
      },
      { label: "日期", required: false, active: false, interface: "date" , dateType: '1'},
      { label: "附件", required: false, active: false, interface: "annex" },
      {
        label: "选择老师",
        required: false,
        active: false,
        interface: "changeTeacher",
        content: [],
        result: [],
        resultContent: []
      },
      {
        label: "选择学生",
        required: false,
        active: false,
        interface: "changeStudent",
        content: [],
        dialogVisible: false
      }
    ];
    return {
      selectList: [true, false],
      options: [
        {
          label: "说明文字",
          value: "descriptionText"
        },
        {
          label: "单选框",
          value: "singlebox"
        },
        {
          label: "多选框",
          value: "checkbox"
        },
        {
          label: "上传图片",
          value: "uploadImg"
        },
        {
          label: "单行输入框",
          value: "singleLineInputbox"
        },
        {
          label: "多行输入框",
          value: "multiLineInputbox"
        },
        {
          label: "日期",
          value: "date"
        },
        {
          label: "附件",
          value: "annex"
        },
        {
          label: "选择老师",
          value: "changeTeacher"
        },
        {
          label: "选择学生",
          value: "changeStudent"
        }
      ],
      label: "",
      textarea: "",
      moblieListValue: "",
      moblieList,
      newMoblieList: [],
      classList: [],
      tableData: [],
      currentClassKey: 0,
      currentKeyNewMoblist: 0,
      declareObject: [],
      declareOptions: [],
      key: 0,
      beyond: false,
      beyonded: false,
      hasImg: false,
      hasAnnex: false
    };
  },
  created() {
    // let content = JSON.parse(this.content)
    this.classList[0] = {};

    this.classList[0].result = [];
  },
  methods: {
    end: function (evt) {
      if(evt.oldIndex === evt.newIndex){
        return;
      }else {
        let arr = [];
        for (let i in this.newMoblieList){
          arr.push(this.newMoblieList[i])
        }
        arr.pop();
        let obj = arr[evt.oldIndex];
        arr.splice(evt.oldIndex, 1);
        arr.splice(evt.newIndex,0,obj);
        for(let j in this.newMoblieList){
          this.newMoblieList[j] = arr[j]
        }
      }
    },
    judge(str) {
      if (str === "") return {};
      str = JSON.parse(str);
      if (typeof str === "string") {
        str = this.judge(str);
      }
      return str;
    },
    selectIng(key, label) {
      // this.moblieList[key].required = !this.moblieList[key].required;
      if (!label) {
        this.newMoblieList[key].required = !this.newMoblieList[key].required;
      }

      // for(let moblieKey in this.moblieList[key]) {
      //     this.moblieList[moblieKey].active = false
      // }
      // this.moblieList[key].active = true
      // this.moblieList[key] = {}
    },
    // 当用户点击项目中的选项时，做出相应的数据变化
    changeMoblie(key) {
      this.key = key;
      this.newMoblieList.forEach(item => {
        item.active = false;
      });
      this.newMoblieList[key].active = true;
      // 选择老师
      if (this.newMoblieList[key].interface === "changeTeacher") {
        this.currentKeyNewMoblist = key;
        this.declareOptions = [];

        this.$https
          .post("/api/blog/student/teachers")
          .then(res => {
            res.data.forEach(item => {
              this.newMoblieList[this.currentClassKey].content.push({
                label: item.name,
                value: item.pinyin,
                id: item.id
              });
            });
          })
          .catch(err => {});
        return;
      }
      // 选择学生
      if (this.newMoblieList[key].interface === "changeStudent") {
        this.currentKeyNewMoblist = key;
        // if(this.newMoblieList[key])
        this.$https
          .get("/api/conn/homework/classList")
          .then(res => {
            return res.data;
          })
          .catch(error => {})
          .then(data => {
            this.classList = [];
            data.forEach((item, key) => {
              this.classList.push({
                value: item.name,
                id: item.id,
                active: false,
                result: []
              });
            });
            this.classList[0].active = true;
            this.classList[0].result = [];
            this.newMoblieList[
              this.currentKeyNewMoblist
            ].content = this.classList;
            this.$https
              .get(`/api/conn/homework/students/${this.classList[0].id}`)
              .then(res => {
                return res.data;
              })
              .catch(error => {})
              .then(data => {
                data.forEach((item, key) => {
                  if (this.classList[0].result) {
                    this.classList[0].result.push(item);
                    this.classList[0].result[key].active = false;
                  }
                });
                let arr = this.classList[0].result;
                this.classList[0].result = [];
                this.classList[0].result = arr;
              });
            this.newMoblieList[key].dialogVisible = true;
          });
        return;
      }
      if (this.newMoblieList[key].interface === "uploadImg") {
      }
    },
    // 上传图片
    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //选中相应学生时，改变content
    handleSelectChange(val, row) {
      let indexKey = this.classList[this.currentClassKey].result.findIndex(
        result => {
          return result.id === row.id;
        }
      );
      let resultActBoo = this.classList[this.currentClassKey].result[indexKey]
        .active;
      this.classList[this.currentClassKey].result[
        indexKey
      ].active = !resultActBoo;
      this.newMoblieList[this.currentKeyNewMoblist].content = this.classList;
      let mobild = this.newMoblieList;
      this.newMoblieList = [];
      this.newMoblieList = mobild;
    },

    fnUploadRequest(option) {
      this.$https
        .post("/api/blog/eRate/getPolicy")
        .then(response => {
          return response.data;
        })
        .catch(error => {
          // err(error)
        })
        .then(data => {
          this.upload(data, option.file);
        });
    },
    upload(data, file) {
      let formData = new FormData();
      let expire = parseInt(data.expire);
      // 文件名hash
      let key = data.dir + "" + file.name;
      let returnUrl = data.host + "/" + key;
      formData.append("OSSAccessKeyId", data.accesskey);
      formData.append("policy", data.policy);
      formData.append("Signature", data.signature);
      formData.append("expire", expire);
      formData.append("key", key);
      formData.append("host", data.host);
      formData.append("success_action_status", "200");
      formData.append("file", file);
      // let url = data.host.replace("http://", "https://");
      let url = data.host;
      this.$https
        .post(url, formData, {
          onUploadProgress: progressEvent => {
            // 这里可以拿到上传的进度;
            let complete =
              (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
            this.progress = complete;
          }
        })
        .then(da => {
          this.newMoblieList[this.currentKeyNewMoblist].urlList.push(returnUrl);
        })
        .catch(error => {});
    },
    // 选中相应的老师
    changeTeacherMethod() {
      // let arr = []
      this.newMoblieList[this.currentKeyNewMoblist].result.forEach(item => {
        arr.push(this.newMoblieList[this.currentKeyNewMoblist].content[item]);
      });
      this.newMoblieList[this.currentKeyNewMoblist].resultContent = arr;
    },
    //选择相应的教室，展示出学生
    selectClass(key) {
      this.classList.forEach(item => {
        item.active = false;
      });
      this.classList[key].active = true;
      this.currentClassKey = key;
      if (this.classList[key].result.length !== 0) {
        return;
      }
      this.$https
        .get(`/api/conn/homework/students/${this.classList[key].id}`)
        .then(res => {
          return res.data;
        })
        .catch(error => {})
        .then(data => {
          data.forEach((item, itemKey) => {
            this.classList[key].result.push(item);
            this.classList[key].result[itemKey].active = false;
          });
        });
      // }
    },
    addMobLieList() {
      setTimeout(() => {
        document.activeElement.blur();
      }, 500);
      const resultObj = {};
      const oldObj = this.moblieList.filter(item => {
        return item.interface === this.moblieListValue;
      })[0];
      for (let key in oldObj) {
        resultObj[key] = oldObj[key];
      }
      if (resultObj.interface === "uploadImg") {
        this.hasImg = true;
      }
      if (resultObj.interface === "annex") {
        this.hasAnnex = true;
      }
      if(this.moblieListValue !== ""){
        this.newMoblieList.push(resultObj);
      }
    },
    deleteOption(key) {
      if (this.newMoblieList[key].interface === "annex") {
        this.hasAnnex = false;
      }
      if (this.newMoblieList[key].interface === "uploadImg") {
        this.hasImg = false;
      }
      this.newMoblieList.splice(key, 1);
    },
    addSubject () {
      let isAdd = true
      let resultObj = {label: "学科", required: true, active: false, interface: "singlebox", content: this.subjectList, forSubject: true}
      this.newMoblieList.forEach(item => {
        if (item.forSubject) {
          isAdd = false
        }
      })
      if (isAdd) {
        this.newMoblieList.unshift(resultObj);
      }
    },
    removeSubject () {
      this.newMoblieList.forEach((item, index) => {
        if (item.forSubject) {
          this.newMoblieList.splice(index, 1)
        }
      })
    }
  },
  activated() {

    let oldContent = this.judge(this.oldContent);
    if(oldContent.result && !oldContent.content) {
      this.newMoblieList = oldContent.result;
    }
  }
};
</script>

<style lang="scss" scoped>
.define-header {
  span {
    color: #333333;
    font-size: 23px;
    font-weight: bold;
    line-height: 31px;
    display: inline-block;
  }
}
.actitiy-content {
  display: flex;
}
.actityLeft {
  display: inline-block;
  .actityLeftHeader {
    margin-top: 15px;
  }
  .actityLeftContent {
    width: 278px;
    min-height: 513px;
    box-shadow: 0px 0px 12px -5px rgba(0, 0, 0, 0.13),
      0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    border-radius: 23px;
    margin-top: 30px;
    overflow: hidden;
    .content-bar {
      width: 148px;
      height: 6px;
      background: rgba(192, 192, 192, 1);
      border-radius: 4px;
      margin: 4px auto;
    }
    .content-box {
      width: 263px;
      min-height: 493px;
      background: #e0e0e0;
      border-radius: 16px;
      margin: 0 auto;
      padding-top: 9px;
      padding-bottom: 1px;
      margin-bottom: 9px;
      span {
        color: #373737;
        font-size: 14px;
        font-weight: bold;
      }
      .box-header {
        padding-top: 32px;
        padding-left: 10px;
        padding-bottom: 20px;
      }
      .boxList {
        padding: 0 2px;
        position: relative;
        .box-item {
          margin-bottom: 10px;
          background: #fff;
          line-height: 35px;
          padding-left: 10px;
          cursor: move;
          overflow: hidden;
          border: 1px solid white;
          .deleteItem {
            display: none;
          }
        }
        .box-item:hover .deleteItem {
          display: block;
        }
        .box-item:hover {
          border: 1px dashed rgba(17, 138, 232, 1);
        }
        .active {
          border: 1px solid rgba(17, 138, 232, 1)!important;
        }
      }
    }
  }
}

.actityRight {
  display: inline-block;
  margin-left: 95px;
  .header {
    .title {
      color: #333333;
      font-size: 14px;
      font-weight: bold;
    }
    .message {
      font-size: 10px;
      color: #979797;
      margin-left: 10px;
    }
  }
  .el-input {
    width: 333px;
    margin-top: 6px;
  }
  .content {
    margin-top: 23px;
    .title {
      color: #333333;
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
      line-height: 27px;
      display: inline-block;
      position: relative;
      top: -8px;
    }
    .select-button {
      background: #ececec;
      display: inline-block;
      border-radius: 13px;
      overflow: hidden;
      cursor: pointer;
      span {
        display: inline-block;
        color: #666;
        background: #ececec;
        line-height: 21px;
        padding: 3px 20px;
      }
      .active {
        color: #fff;
        background: #2196f3;
        border-radius: 13px;
      }
      .none {
        font-weight: bold;
      }
    }
  }
  .option {
    margin-top: 20px;
  }
}
.text /deep/ .el-textarea {
  textarea {
    resize: none;
    height: 210px;
    margin-top: 10px;
  }
}
.option /deep/ .el-dialog {
  .avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #000;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.option /deep/ .study {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  margin: 0;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    text-align: center;
    padding-bottom: 10px;
  }
  .content {
    height: 90%;
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    margin: 0;
  }
}
.actityLeftHeader /deep/ .el-select {
  width: 150px;
  height: 32px;
  .el-select__tags {
    .el-tag--light {
      background: rgba(230, 244, 255, 1);
      border-radius: 14px;
      .el-select__tags-text {
        color: #2196f3ff;
      }
      .el-icon-close {
        color: #2196f3ff;
        background: #a9d9ffff;
      }
    }
  }
}
.my-el-scroll {
  .el-scrollbar {
    .el-select-dropdown__wrap {
      background: #000;
    }
  }
}
  .not-allowed{
    cursor: not-allowed!important;
    opacity: .5;
  }
</style>
